/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../types/graph';

import * as Operations from './mutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type UpdateResidenceZipMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.ResidenceProfileUpdateMutationInput;
}>;


export type UpdateResidenceZipMutation = { __typename?: 'Mutation', customers: { __typename?: 'CustomersMutation', residence_profile_update: { __typename?: 'ResidenceProfile', id: string, zipCode: string | null } | null } };


export function useUpdateResidenceZipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResidenceZipMutation, UpdateResidenceZipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResidenceZipMutation, UpdateResidenceZipMutationVariables>(Operations.UpdateResidenceZip, options);
      }
export type UpdateResidenceZipMutationHookResult = ReturnType<typeof useUpdateResidenceZipMutation>;